import React, { FC } from 'react'
import { FormItemProps, TextAreaProps as AntdTextAreaProps } from 'formik-antd'
import { FormItem, Input as AntInput } from '@src/helpers/Formik/formikAntdCompat'
import { useTranslation } from 'react-i18next'
const AntTextarea = (AntInput as any).TextArea

interface TextAreaProps extends Omit<AntdTextAreaProps, 'name'>, Pick<FormItemProps, 'label' | 'name'> {
  placeholder?: string
  required?: boolean
  type: string
}

export const TextArea: FC<TextAreaProps> = ({ label, name, placeholder, required, ...props }) => {
  const { t } = useTranslation()

  return (
    <FormItem labelCol={{ span: 24 }} label={label} name={name} required={required}>
      <AntTextarea {...props} placeholder={placeholder || t('forms.validation.info.noValueSet')} name={name} />
    </FormItem>
  )
}
